export default "__VITE_ASSET__503fa432__"